import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../../data/content';
import { OptimizedImage } from '../OptimizedImage';
import { CtaButton } from '../CtaButton';
import { OfferTimer } from '../OfferTimer';
export function Bonuses() {
  return <section className="bg-brand-950 py-10 text-white lg:py-16" aria-labelledby="bonuses-title" data-id="element-238" data-mp="1cj3ayl67xja8">
      <div className="mx-auto max-w-6xl px-5" data-id="element-239" data-mp="18hhwwwhy6yyg">
        <p className="mx-auto mb-3 flex w-fit items-center gap-2 rounded-full bg-sun px-4 py-1.5 font-display text-xs font-extrabold uppercase tracking-[0.18em] text-ink sm:text-sm" style={{
        backgroundColor: "#FFE17A",
        backgroundImage: "none"
      }} data-id="element-240" data-mp="25a3llez21lav">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-241" data-mp="1ra2gtofo5tq4" />
          SOLO POR HOY
        </p>
        <h2 id="bonuses-title" className="mx-auto max-w-2xl text-center" data-id="element-242" data-mp="ku0bdipa0x3x">
          <span className="block font-display text-base font-bold leading-snug text-brand-100 sm:text-xl" data-id="element-243" data-mp="krx9o1erhfjd">
            Y además, con tu compra te llevás
          </span>
          <span className="mt-2 flex items-center justify-center gap-2.5" data-id="element-244" data-mp="1euyf07zayjdw">
            <span className="btn-gold relative flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-lg text-ink sm:h-11 sm:w-11" data-id="element-245" data-mp="1jt9m4ay7qfsf">
              <GiftIcon className="relative h-5 w-5 sm:h-6 sm:w-6" aria-hidden="true" data-id="element-246" data-mp="15v2z5pusy07j" />
            </span>
            <span className="text-gold-shine font-display text-[40px] font-extrabold uppercase leading-none tracking-tight sm:text-6xl" style={{
            fontSize: "25px",
            fontStyle: "normal"
          }} data-id="element-247" data-mp="1au6294r81wcv">
              5 bonos exclusivos
            </span>
          </span>
        </h2>

        <OfferTimer label="ESTA OFERTA TERMINA EN " className="mt-5" data-id="element-248" data-mp="n0ny7uoxjxh2" />

        <ul className="mx-auto mt-5 flex max-w-2xl flex-col gap-1.5 lg:mt-6" data-id="element-249" data-mp="r4lwy4acf69l">
          {bonuses.map(b => <li key={b.number} className="flex items-center gap-2.5 overflow-hidden rounded-xl bg-white/5 p-1.5 ring-1 ring-white/10 sm:gap-3" data-id="element-250" data-mp="d4tcgqpetma2">
              <OptimizedImage src={b.image} alt={b.imageAlt} width={128} height={128} className="aspect-square h-14 w-14 shrink-0 rounded-md bg-white object-cover sm:h-16 sm:w-16" data-id="element-251" data-mp="2jsjzas90vzn5" />
              <div className="min-w-0 flex-1 pr-1.5 sm:pr-3" data-id="element-252" data-mp="2f00ilmf1goe4">
                <h3 className="flex items-center gap-1.5 font-display text-[13px] font-extrabold leading-tight sm:text-[15px]" data-id="element-253" data-mp="2b11jiifznlul">
                  <span className="shrink-0 rounded bg-sun px-1 py-0.5 text-[9px] uppercase leading-none text-ink sm:text-[10px]" data-id="element-254" data-mp="25z2el44logvj">B{b.number}</span>
                  <span className="min-w-0" data-id="element-255" data-mp="2ypkrewv4lwm5">{b.title}</span>
                </h3>
                <p className="mt-0.5 line-clamp-1 text-[11.5px] leading-snug text-brand-100 sm:text-[13px]" data-id="element-256" data-mp="2tqhl793etkcl">{b.description}</p>
                <ul className="mt-1 hidden flex-wrap gap-1 sm:flex" data-id="element-257" data-mp="2oqlfn5f2dkux">
                  {b.points.map(p => <li key={p} className="rounded-full bg-white/10 px-1.5 py-0.5 text-[10px] font-semibold leading-tight text-white sm:px-2 sm:text-[11px]" data-id="element-258" data-mp="1ibujtg4ssq7r">
                      {p}
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-2xl text-center font-display text-base font-extrabold uppercase leading-snug tracking-tight text-white sm:text-xl" data-id="element-259" data-mp="187e5wsavpj6l">
          5 bonos para llevar tu preparación <span className="text-sun" data-id="element-260" data-mp="1hxgwymyfwn2a">un paso más allá.</span>
        </p>
        <div className="mx-auto mt-4 flex max-w-md justify-center sm:max-w-none" data-id="element-261" data-mp="1hys2ar7ja2vi">
          <CtaButton className="w-full sm:w-auto" data-id="element-262" data-mp="1lyiwl4w9r14s" />
        </div>
      </div>
    </section>;
}